import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SharedModule } from '@shared/shared.module';
import {CommandService} from '@core/services/command.service';
import {spreadsheetRoutes} from '@features/spreadsheet/spreadsheet.routes';
import {SpreadsheetDynamicComponentHelper} from '@features/spreadsheet/spreadsheet-dynamic-component-helper';
import {
  PlatformToolSpreadsheetEditorComponent
} from './components/platform-tool-spreadsheet-editor/platform-tool-spreadsheet-editor.component';
import {PlatformToolSpreadsheetHandler} from '@features/spreadsheet/services/platform-tool-spreadsheet-handler';
import {ProjectsDynamicComponentHelper} from '@features/projects/projects-dynamic-component-helper';
import { WorkbookContainerComponent } from './components/workbook-container/workbook-container.component';
import { WjGridSheetModule } from '@grapecity/wijmo.angular2.grid.sheet';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';
import { FlexSheetDataService } from '@features/spreadsheet/services/flex-sheet-data.service';
import { FlexSheetService } from '@features/spreadsheet/services/flex-sheet.service';
import { SpreadsheetManageEntityDialogComponent } from './components/dialog-components/spreadsheet-manage-entity-dialog/spreadsheet-manage-entity-dialog.component';
import { ManageEntityCommandHandler } from './manage-entity-command-handler';
import { WorkflowModule } from '@features/workflow/workflow.module';
import { EntityChartModule } from '@features/entity-chart/ed-entity-data/entity-chart.module';
import { ManageStageAreaCommandHandler } from './services/manage-stage-area-command-handler';
import { ShareWorkbookSetCommandHandler } from './services/share-worbook-set-command-handler';
import { ManageStageAreaDialogComponent } from './components/dialog-components/manage-stage-area-dialog/manage-stage-area-dialog.component';
import { FlexSheetCellTemplateCreateService } from '@features/spreadsheet/services/flex-sheet-cell-template-create.service';
import { SpreadsheetReducer } from './store/spreadsheet.reducer';
import { StoreModule } from '@ngrx/store';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { AddRemoveWorkbooksCommandHandler } from './services/add-remove-workbook-command-handler';
import { FileManagerModule } from '@features/file-manager/file-manager.module';
import { FlexSheetStyleManagementService } from '@features/spreadsheet/services/flex-sheet-style-management.service';
import { CreateQuestionnaireFromExcelCommandHandler } from './services/create-questionnaire-from-excel-command-handler';
import { CreateQuestionnaireFromExcelDialogComponent } from './components/dialog-components/create-questionnaire-from-excel-dialog/create-questionnaire-from-excel-dialog.component';
import { FormsModule } from '@angular/forms';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { ExcelTableInputCardComponent } from './components/cards/excel-table-input-card/excel-table-input-card.component';
import { ExcelColumnCellViewerComponent } from './components/cell-viewer/excell-column-cell-viewer/excell-column-cell-viewer.component';
import { ConfigureExcelAsFormService } from '@features/spreadsheet/services/configure-excel-as-form.service';
import { FormulaFieldCellViewerComponent } from './components/cell-viewer/formula-field-cell-viewer/formula-field-cell-viewer.component';
import { StepByStepWorkbookGuideCardComponent } from './components/cards/step-by-step-workbook-guide-card/step-by-step-workbook-guide-card.component';
import {StepByStepWorkbookGuideService} from '@features/spreadsheet/services/step-by-step-workbook-guide.service';
import { VirtualPlaceHolderComponent } from './components/virtual-place-holder/virtual-place-holder.component';
import { SpreadsheetGuidedTourComponent } from './components/spreadsheet-guided-tour/spreadsheet-guided-tour.component';
import { OverwriteReviewSidebarComponent } from './components/overwrite-review-sidebar/overwrite-review-sidebar.component';
import {RemoveDataExtractorMappingCommandHandler} from '@features/spreadsheet/services/remove-entity-account-mapping-command-handler';
import { SideNoteContainerComponent } from './components/sidenotes/side-note-container/side-note-container.component';
import {OECDTaxRiskIndicatorsComponent} from '@features/spreadsheet/components/footnotes/oecd-tax-risk-indicators/oecd-tax-risk-indicators.component';
import { ExcelFootNoteComponent } from './components/sidenotes/excel-foot-note/excel-foot-note.component';
import {ExcelFormWarningGridHandler} from '@features/spreadsheet/services/excel-form-warning-grid-handler.service';
import { FormViewInstructionsComponent } from './components/sidenotes/form-view-instructions/form-view-instructions.component';
import {EffectsModule} from '@ngrx/effects';
import {SpreadsheetEffects} from '@features/spreadsheet/store/spreadsheet.effects';
import { SpreadsheetSearchDialogComponent } from './components/dialog-components/spreadsheet-search-dialog/spreadsheet-search-dialog.component';
import {StepByStepProcessComponent} from '@features/spreadsheet/components/step-by-step-process/step-by-step-process.component';
import { ValidationWarningsIconCellViewerComponent } from './components/cell-viewer/validation-warnings-icon-cell-viewer/validation-warnings-icon-cell-viewer.component';
import { GenerateCbCNotificationGridHandler } from '@features/spreadsheet/services/generate-cbc-notification-grid-handler';
import { ButtonCellViewerComponent } from './components/cell-viewer/button-cell-viewer/button-cell-viewer.component';
import { WorkbookSearchGridHandler } from './services/workbook-search-grid-handler';
import { AbbreviationsComponent } from './components/sidenotes/abbreviations/abbreviations.component';
import { ReportWorksheetDetailsAndInstructionsComponent } from './components/sidenotes/worksheet-details-and-instructions/report-worksheet-details-and-instructions.component';
import { ScenarioActivityComponent } from './components/scenario-activity/scenario-activity.component';
import {PlatformCommand} from "@shared/commands/command-base";
import {Api} from "@shared/constants/common-field.constants";


@NgModule({
  imports        : [
    CommonModule,
    EntityChartModule,
    WorkflowModule,
    RouterModule.forChild(spreadsheetRoutes),
    WjGridSheetModule,
    WjInputModule,
    SharedModule,
    WorkflowModule,
    StoreModule.forFeature('spreadsheet', SpreadsheetReducer),
    EffectsModule.forFeature([SpreadsheetEffects]),
    DragDropModule,
    FileManagerModule,
    FormsModule,
    ScrollingModule
  ],
  declarations   : [
    PlatformToolSpreadsheetEditorComponent,
    WorkbookContainerComponent,
    SpreadsheetManageEntityDialogComponent,
    ManageStageAreaDialogComponent,
    CreateQuestionnaireFromExcelDialogComponent,
    ExcelTableInputCardComponent,
    ExcelColumnCellViewerComponent,
    FormulaFieldCellViewerComponent,
    ValidationWarningsIconCellViewerComponent,
    StepByStepWorkbookGuideCardComponent,
    VirtualPlaceHolderComponent,
    SpreadsheetGuidedTourComponent,
    OverwriteReviewSidebarComponent,
    SideNoteContainerComponent,
    OECDTaxRiskIndicatorsComponent,
    ExcelFootNoteComponent,
    FormViewInstructionsComponent,
    SpreadsheetSearchDialogComponent,
    StepByStepProcessComponent,
    ButtonCellViewerComponent,
    AbbreviationsComponent,
    ReportWorksheetDetailsAndInstructionsComponent,
    ScenarioActivityComponent
  ],
  exports        : [
    ExcelTableInputCardComponent,
    StepByStepWorkbookGuideCardComponent,
    SpreadsheetGuidedTourComponent,
    OverwriteReviewSidebarComponent,
    StepByStepProcessComponent
  ],
  providers      : [
    FlexSheetDataService,
    FlexSheetService,
    FlexSheetCellTemplateCreateService,
    ConfigureExcelAsFormService,
    FlexSheetStyleManagementService,
    StepByStepWorkbookGuideService
  ]
})
export class SpreadsheetModule {
  constructor (private commandService: CommandService,
    private platformToolSpreadsheetHandler: PlatformToolSpreadsheetHandler,
    private manageEntityCommandHandler: ManageEntityCommandHandler,
    private manageStageAreaCommandHandler: ManageStageAreaCommandHandler,
    private shareWorkbookSetCommandHandler: ShareWorkbookSetCommandHandler,
    private removeDataExtractorMappingCommandHandler: RemoveDataExtractorMappingCommandHandler,
    private addRemoveWorkbooksCommandHandler: AddRemoveWorkbooksCommandHandler,
    private createQuestionnaireFromExcelCommandHandler: CreateQuestionnaireFromExcelCommandHandler,
    private excelWarningGridHandler: ExcelFormWarningGridHandler,
    private generateCbCNotificationGridHandler: GenerateCbCNotificationGridHandler,
    private workbookSearchGridHandler: WorkbookSearchGridHandler
    ) {
    SpreadsheetDynamicComponentHelper.init();
    ProjectsDynamicComponentHelper.register('PlatformToolSpreadsheetHandler', platformToolSpreadsheetHandler);
    ProjectsDynamicComponentHelper.register('ExcelFormWarningGridHandler', excelWarningGridHandler);
    SpreadsheetDynamicComponentHelper.register('ManageEntityCommandHandler', manageEntityCommandHandler);
    SpreadsheetDynamicComponentHelper.register('ManageStageAreaCommandHandler', manageStageAreaCommandHandler);
    SpreadsheetDynamicComponentHelper.register('ShareWorkbookSetCommandHandler', shareWorkbookSetCommandHandler);
    SpreadsheetDynamicComponentHelper.register('AddRemoveWorkbooksCommandHandler', addRemoveWorkbooksCommandHandler);
    SpreadsheetDynamicComponentHelper.register('RemoveDataExtractorMappingCommandHandler', removeDataExtractorMappingCommandHandler);
    SpreadsheetDynamicComponentHelper.register('CreateQuestionnaireFromExcelCommandHandler', createQuestionnaireFromExcelCommandHandler);
    SpreadsheetDynamicComponentHelper.register('GenerateCbCNotificationGridHandler', generateCbCNotificationGridHandler);
    SpreadsheetDynamicComponentHelper.register('WorkbookSearchGridHandler', workbookSearchGridHandler);

    let command = new PlatformCommand('CreateJobAnalysisPlatformToolLinkCommand', Api.Spreadsheet);
    this.commandService.registrPlatformLinkCommand('/logs/job-data-analysis', command);
  }
}

